
import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, mergeMap } from "rxjs/operators";
import { GenericDocumentService } from "../../services/generic-document.service";
import { DSTActionTypes } from "./doc-stereo-type-action";

@Injectable()
export class DSTEffects {

    dbname!: string;

    loadDocStereoTypes = createEffect(() =>
        this.actions$.pipe(
            ofType(DSTActionTypes.InvokeGenericDocumentApiType),
            mergeMap((action: any) => {
                return this.genericDocumentService.getDocStereoTypes('', 1, 10, action.dbname)
                    .pipe(map((data) => ({ type: DSTActionTypes.RetrievedDstListType, docstereotypes: data })))
            })));

    constructor(private actions$: Actions, private genericDocumentService: GenericDocumentService) { }
}